import React, {useState} from 'react';
import {makeStyles} from '@mui/styles';
import MaterialTable, {MTableToolbar} from '@material-table/core';
import LoadingSpinner from "../../../../../components/Spinner/loading.spinner";
import {EmptyList} from "../../../../../components/EmptyList";
import {Avatar, List, ListItem, ListItemIcon, ListItemText, Typography} from "@mui/material";
import palette from '../../../../../theme/palette';
import PersonIcon from "@mui/icons-material/Person";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(0),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0)
  },
  content: {
    margin: 0,
  },
  paper: {
    width: '100%'
  },
  blankSection: {
    height: 50,
    fontSize: '16px',
    fontWeight: 'bold',
    color: theme.palette.white
  },
  emptyAvatarStyle: {
    margin: 10,
    width: '100%',
    height: 50
  },
  avatarStyle:  {
    marginRight: 0,
    width: 100,
    height: 20
  },
  section: {
    color: theme.palette.white
  },
  title: {
    fontWeight: 'bold',
    color: theme.palette.text,
    fontSize: 14
  },
  detail: {
      fontSize: 14,
      color: theme.palette.text.primary,
      // backgroundColor: '#FDD835',
      marginLeft: 20
  },
  iconColor: {
      color: '#228b22',
  }

}));

const RecentSharedUserTable = (props) => {
  const {
    documents
  } = props;

  const [isLoading, setLoading] = useState(false);
  const classes = useStyles();

  const statusColors = {
    Public: palette.publicSection,
    Company: palette.companySection,
    Private: palette.privateSection
  };

  const headers = [
    {
      title: 'Section',
      field: 'section',
      render: document =>
        <Avatar
            className={classes.avatarStyle}
            style={{backgroundColor: statusColors[document.section]}}
            variant="rounded"
        >
          <Typography
            align="center"
            className={classes.section}
            color="textPrimary"
            component="span"
            style={{backgroundColor: statusColors[document.section]}}
            variant="body2"
          >
            {document.section}
          </Typography>
        </Avatar>
    },
    {
      title: 'Document Name',
      field: 'documentName',
      cellStyle: {
        width: '90%',
        maxWidth: '90%'
      },
      render: document =>
        <React.Fragment>
          <Typography
              className={classes.title}
              color="textPrimary"
              component="span"
              variant="body2"
          >
            {document.documentName}
          </Typography>
        </React.Fragment>
    },
    {
      title: 'Shares',
      field: 'numberOfShares',
      render: document =>
        <React.Fragment>
          <Typography
              className={classes.title}
              color="textPrimary"
              component="span"
              variant="body2"
          >
            {document.numberOfShares}
          </Typography>
          <Typography>
            Shares
          </Typography>
        </React.Fragment>
    },
  ];

  // let detailPanel = [];
  //
  // for

  const detailPanel=[
    {
      render: rowData => {
        return (
          <React.Fragment>
            {rowData.rowData.sharedToUsers.map((sharedUser) => (
            <ListItem
              className={classes.detail}
              divider={true}
              key={sharedUser}
            >
              <ListItemIcon className={classes.iconColor}
              >
                <PersonIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <React.Fragment>
                    <Typography
                      className={classes.title}
                      color='textPrimary'
                      component="span"
                      variant="body2"
                    >
                      {sharedUser}
                    </Typography>
                  </React.Fragment>}
              />
            </ListItem>
          ))}
          </React.Fragment>
        )
      },
    }
  ]

  return (
    <div className={classes.root}>
        {(!document) ? (<LoadingSpinner/>) :
          (
          <div className={classes.content}>
            {isLoading ? (<LoadingSpinner/>) : (
              <MaterialTable
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <EmptyList
                        label="No Documents to Display!"
                      />
                    ),
                  },
                }}
                style={{width: "100%", height: "100%", padding: 0}}
                title=""
                options={{
                  rowStyle: {
                    padding: 0,
                    margin: 0
                  },
                  columnResizable: true,
                  idSynonym: "guid",
                  emptyRowsWhenPaging: false,
                  paging: false,
                  pageSize: 20,
                  search: false,
                }}
                columns={headers}
                data={documents}
                detailPanel={detailPanel}
              />
            )}
          </div>
          )}
    </div>
  )
}
;

export default RecentSharedUserTable;
